import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

const useHook = () => {
  return useQuery(['admin-progress'], async () => {
    const response = await service.get(`progress`);
    return response.data.data;
  });
};

export default useHook;
